<script>
export default {
  name: "dashboard-card",
  props: ["title", "value", "img", "loading"]
};
</script>

<template>
  <v-card elevation="2" :loading="loading">
    <div class="p-3">
      <div class="d-flex align-items-center">
        <!--begin::Symbol-->
        <div class="symbol symbol-50 mr-5 symbol-light-primary">
          <span class="symbol-label">
            <span class="svg-icon svg-icon-xl svg-icon-primary">
              <!--begin::Svg Icon-->
              <inline-svg :src="img"></inline-svg>
              <!--end::Svg Icon-->
            </span>
          </span>
        </div>
        <!--end::Symbol-->
        <!--begin::Text-->
        <div class="d-flex flex-column font-weight-bold">
          <span class="text-dark font-size-h3">
            {{ value }}
          </span>
          <span class="text-muted">
            {{ title }}
          </span>
        </div>
        <!--end::Text-->
      </div>
    </div>
  </v-card>
</template>
